export const ROLE_AIDWOPS_DASHBOARD = "APL213643-myhelp-AiDWOPs";

export const AIDWOPS_ASSISTANT_PROMPTS = [
    "What needs my attention today?",
    "Why is WeTransfer.com blocked?",
    "Does I18809@bic.eon.com have access to MyGenius?",
    "Summarize Intune policy hygiene",
    "Which devices need battery attention?"
];